import { Component, Inject, Optional, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthenticationService } from 'src/core/http/authentication.service';
import { BaseComponent } from '../base.component';


@Component({
  selector: 'app-dialog-json-box',
  templateUrl: './dialog-json-box.component.html',
  styleUrls: ['./dialog-json-box.component.scss']
})

export class DialogJsonBoxComponent extends BaseComponent implements OnInit {

  rawJson: any;

  constructor(
    public dialogRef: MatDialogRef<DialogJsonBoxComponent>,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    public authenticationService: AuthenticationService,) {
      super(authenticationService);
      
    try {
      this.rawJson = JSON.parse(data);
    }
    catch (exception) {
      this.rawJson = "Error: Cannot parse JSON.";
    }
    
  }


  ngOnInit(): void {
  }


  closeDialog() {
    this.dialogRef.close();
  }

}
